/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackageFieldsSchemaDtoPage } from '../../models/work-package-fields-schema-dto-page';

export interface ListWorkPackageFieldsSchema$Params {
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'fields' | '-fields' | 'isCurrent' | '-isCurrent' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listWorkPackageFieldsSchema(http: HttpClient, rootUrl: string, params?: ListWorkPackageFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageFieldsSchemaDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listWorkPackageFieldsSchema.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageFieldsSchemaDtoPage>;
    })
  );
}

listWorkPackageFieldsSchema.PATH = '/v0/WorkPackageFieldsSchema';
